<template>
  <div class="identification-methods">
    <identification-method-item
      v-if="availableMethods.includes('external-sc')"
      data-cy="externalSwisscom"
      icon="custom:business_profile"
      :title="$t('ident_method.external.swisscom.title')"
      :description="$t('ident_method.external.swisscom.text')"
      :href="identShopUrl"
      @click="$emit('select', 'external-sc')"
    />
    <identification-method-item
      v-if="availableMethods.includes('self')"
      data-cy="selfIdentBtn"
      icon="custom:mobile_contact"
      :title="$t('eu_ident.self.title')"
      :description="$t('eu_ident.self.text')"
      @click="$emit('select', 'self')"
    />
    <identification-method-item
      v-if="availableMethods.includes('auto')"
      icon="custom:ident"
      :title="$t('ch_ident.auto.title')"
      :description="$t('ch_ident.auto.text')"
      @click="$emit('select', 'auto')"
    />
    <template v-if="availableMethods.includes('id-austria')">
      <identification-method-item
        :title="$t('ident_method.id_austria.title')"
        :description="$t('ident_method.id_austria.text')"
        @click="showIdAustriaDialog = true"
      >
        <template #icon>
          <nuxt-img src="/img/id-austria-logo.png" :width="30" alt="ID Austria" />
        </template>
      </identification-method-item>
      <dialog-connect-id-austria v-model="showIdAustriaDialog" />
    </template>
    <div v-if="availableMethods.includes('loc')" class="location-item">
      <div class="flex-grow-1">
        {{ $t('unlock_qes.ch.personal.sub_text_new') }}
      </div>
      <div class="ml-4">
        <v-btn color="info" variant="outlined" size="x-large" :href="$t('unlock_qes.ch.personal.location_link')">
          {{ $t('unlock_qes.ch.personal.location') }}
        </v-btn>
      </div>
    </div>
    <a v-if="showHelpLink" class="help-link" target="_blank" rel="noopener" :href="helpCenterUrl">
      {{ $t('ident_methods.help_link.text') }}
    </a>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

import DialogConnectIdAustria from '@/components/dialogs/DialogConnectIdAustria.vue'
import IdentificationMethodItem from '@/components/identification/IdentificationMethodItem.vue'

export default defineComponent({
  name: 'IdentificationMethods',
  components: {
    DialogConnectIdAustria,
    IdentificationMethodItem,
  },
  props: {
    availableMethods: {
      type: Array as PropType<IdentificationMethod[]>,
      default: () => ['self', 'auto', 'loc', 'id-austria'],
    },
    showHelpLink: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select'],
  setup() {
    return {
      identShopUrl: useIdentShopUrl(),
    }
  },
  data() {
    return {
      showIdAustriaDialog: false,
      externalLinkId: Math.floor(Math.random() * 10000).toString(),
    }
  },
  computed: {
    helpCenterUrl(): string {
      return this.$t('ident_methods.help_link.url') as string
    },
  },
})
</script>

<style lang="sass" scoped>
@use 'sass:color'

.identification-methods
  > * + *
    margin-top: 6 * $base-width

.location-item
  display: flex
  align-items: center
  padding-top: 5 * $base-width
  padding-bottom: 5 * $base-width
  margin-top: 6 * $base-width
  border-top: 1px solid $c-border
  border-bottom: 1px solid $c-border

.help-link
  display: block
  color: $c-grey-dark-2

  &:hover
    color: color.adjust($c-grey-dark-2, $lightness: 10%)
</style>
